import { apiRequest } from './http';

// 세션 상태 확인 응답 (backend `/api/auth/me`).
export interface AuthMeResponse {
  email: string;
  source: string;
  is_default: boolean;
  oauth_configured: boolean;
}

// 현재 세션 확인. 인증 안 되어 있으면 ApiHttpError(401).
export function fetchAuthMe(signal?: AbortSignal): Promise<AuthMeResponse> {
  return apiRequest<AuthMeResponse>('/auth/me', { signal });
}

// 세션 종료. 쿠키는 backend에서 set-cookie로 만료시킨다.
export function logout(): Promise<unknown> {
  return apiRequest<unknown>('/auth/logout', { method: 'POST' });
}

// Google OAuth 로그인 시작. 페이지 이동을 수반하므로 fetch 대신 location 변경.
export function startGoogleLogin(returnTo?: string): void {
  const url = new URL('/api/auth/google/login', window.location.origin);
  if (returnTo) {
    url.searchParams.set('return_to', returnTo);
  }
  window.location.href = url.toString();
}

// ── 로컬 전용 테스트 로그인 (DEV_TEST_LOGIN_ENABLED) ──────────────────────────
export interface DevLoginAccount {
  email: string;
  role: string; // 'admin' | 'leader' | 'member' | 'none'
  label: string;
}

export interface DevLoginOptions {
  enabled: boolean;
  accounts: DevLoginAccount[];
}

// 테스트 로그인 노출 여부(비인증 공개 엔드포인트). 프로덕션은 enabled=false.
export function fetchDevLoginOptions(signal?: AbortSignal): Promise<DevLoginOptions> {
  return apiRequest<DevLoginOptions>('/auth/dev/login-options', { signal });
}

// 테스트 계정으로 로그인(세션 발급 후 redirect). 페이지 이동을 수반.
export function startDevLogin(email: string, returnTo?: string): void {
  const url = new URL('/api/auth/dev/login', window.location.origin);
  url.searchParams.set('email', email);
  if (returnTo) {
    url.searchParams.set('return_to', returnTo);
  }
  window.location.href = url.toString();
}
